import { IGiftPromocodeInfo } from "../UserStatuses.t";
import { UserStatusPromocodeInfoStyled } from "./styled/UserStatusPromocodeInfoStyled";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import amountFormat from "../../../utils/amountFormat";
import { Button } from "react-bootstrap";
import BinIcon from "../../../components/icon/IconWrapped";
import BadgeOval from "../../../components/BadgeOval/BadgeOval";

function UserStatusPromocodeInfo(props: IGiftPromocodeInfo & { onTopUpHandler: () => void }) {
    const { getLangPath } = useLangContext();

    return <UserStatusPromocodeInfoStyled>
        <div>
            <div className={'mb-2 text-secondary font-size-14'}>{
                (props.user_promocode_status && props.user_promocode_status !== 'created')
                    ? getLangPath('user_statuses.promocode.applied')
                    : getLangPath('user_statuses.promocode.unused')
            }</div>
            <BadgeOval size={'sm'} variant={'bonus'}>
                {
                    props.user_promocode_status === 'used'
                        ? <BinIcon name={'IcCheckMark'}/>
                        : <>
                            +{amountFormat(props.amount, 0)}{props.amount_type === 'percent' ? '%' : ''}
                        </>
                }

            </BadgeOval>
        </div>
        {
            props.user_promocode_status === 'created' && <div>
                <Button variant={'secondary'} size={'sm'} className={'text-nowrap'} onClick={props.onTopUpHandler}>
                    {getLangPath('user_statuses.promocode.top_up')} <BinIcon name={'IcPlusCircle'} size={16}
                                                                             className={'text-primary'}/>
                </Button>
            </div>
        }

    </UserStatusPromocodeInfoStyled>
}

export default UserStatusPromocodeInfo;
